import { getAbsoluteUrl, getEnv, getEnvStringValue } from './env.helpers';

export const environment = {
    REDUX_DEV_TOOLS: getEnv<boolean | undefined>('NEXT_PUBLIC_REDUX_DEV_TOOLS'),
    CHECKOUT_API_END_POINT: getAbsoluteUrl(
        getEnvStringValue('NEXT_PUBLIC_CHECKOUT_API_ENDPOINT', 'CHECKOUT_API_ENDPOINT') ?? '',
    ),
    ACCOMMODATION_API_ENDPOINT: getAbsoluteUrl(
        getEnvStringValue('NEXT_PUBLIC_ACCOMMODATION_API_ENDPOINT', 'ACCOMMODATION_API_ENDPOINT') ??
            '',
    ),
    NOC_API_END_POINT: getAbsoluteUrl(
        getEnvStringValue('NEXT_PUBLIC_NOC_API_ENDPOINT', 'NOC_API_ENDPOINT') ?? '',
    ),
    CROSSSTORAGE_ENDPOINT: getEnvStringValue('NEXT_PUBLIC_CROSSSTORAGE_ENDPOINT'),
    API_DATE_FORMAT: getEnvStringValue('NEXT_PUBLIC_API_DATE_FORMAT'),
    GFX_SERVER: getEnvStringValue('NEXT_PUBLIC_GFX_SERVER'),
    CONSENTS_URLS: {
        privacyPolicy: getEnvStringValue('NEXT_PUBLIC_CONSENTS_URLS_PRIVACY_POLICY'),
        reservationTermsSzallas: getEnvStringValue(
            'NEXT_PUBLIC_CONSENTS_URLS_RESERVATION_TERMS_SZALLAS',
        ),
        privacyPolicySzallas: getEnvStringValue('NEXT_PUBLIC_CONSENTS_URLS_PRIVACY_POLICY_SZALLAS'),
    },
    NOCOWANIE_URL: getEnvStringValue('NEXT_PUBLIC_NOCOWANIE_URL'),
    NOCIMG_URL: getEnvStringValue('NEXT_PUBLIC_NOCIMG_URL'),
    FACEBOOK_APP_ID: getEnvStringValue('NEXT_PUBLIC_FACEBOOK_APP_ID'),
    GTM: {
        GTM_TAG_ID: getEnvStringValue('NEXT_PUBLIC_GTM_TAG_ID'),
        GTM_AUTH: getEnvStringValue('NEXT_PUBLIC_GTM_AUTH'),
        GTM_PREVIEW: getEnvStringValue('NEXT_PUBLIC_GTM_PREVIEW'),
    },
    SALESMANAGO_SMID: getEnvStringValue('NEXT_PUBLIC_SALESMANAGO_SMID'),
    WPH_PIXEL_ID: getEnvStringValue('NEXT_PUBLIC_WPH_PIXEL_ID'),
    SENTRY: {
        SENTRY_DSN: getEnvStringValue('NEXT_PUBLIC_SENTRY_DSN'),
        SENTRY_ENABLED: getEnv<boolean>('NEXT_PUBLIC_SENTRY_ENABLED'),
        SENTRY_ENVIRONMENT: getEnvStringValue(
            'NEXT_PUBLIC_SENTRY_ENVIRONMENT',
            'SENTRY_ENVIRONMENT',
        ),
        SENTRY_PROJECT_NAME: getEnvStringValue('NEXT_PUBLIC_SENTRY_PROJECT_NAME'),
        TUNNEL_URL: getEnvStringValue('NEXT_PUBLIC_SENTRY_TUNNEL_URL'),
    },
    SSR_API_HOST: getAbsoluteUrl(
        getEnvStringValue('NEXT_PUBLIC_SSR_API_HOST', 'SSR_API_HOST') ?? '',
    ),
    ASSETS_PATH: getEnvStringValue('NEXT_PUBLIC_ASSETS_PATH') ?? '',
    ASSETS_PREFIX: getEnvStringValue('NEXT_PUBLIC_ASSETS_PREFIX') ?? '',
    CEPH_URL: getEnvStringValue('NEXT_PUBLIC_CEPH_URL') ?? '',
    SESSION_ID_COOKIE: getEnvStringValue('NEXT_PUBLIC_SESSION_ID_COOKIE'),
    SM_ENDPOINT: getEnvStringValue('SM_ENDPOINT') ?? '',
    SM_CLIENT_ID: getEnvStringValue('SM_CLIENT_ID') ?? '',
    SM_API_KEY: getEnvStringValue('SM_API_KEY') ?? '',
    SM_SHA: getEnvStringValue('SM_SHA') ?? '',
    SM_OWNER_EMAIL: getEnvStringValue('SM_OWNER_EMAIL') ?? '',
    AUTOCOMPLETE_ES_VERSION: getEnv<number | undefined>('NEXT_PUBLIC_AUTOCOMPLETE_ES_VERSION') ?? 2,
    GEO_TILES_ES_VERSION: getEnv<number | undefined>('NEXT_PUBLIC_GEO_TILES_ES_VERSION') ?? 1,
    HOME_PAGE_ES_VERSION: getEnv<number | undefined>('NEXT_PUBLIC_HOME_PAGE_ES_VERSION') ?? 1,
    ACCOMMODATION_PAGE_ES_VERSION:
        getEnv<number | undefined>('NEXT_PUBLIC_ACCOMMODATION_PAGE_ES_VERSION') ?? 1,
    IMAGE_MULTIPLIER: getEnv<number>('NEXT_PUBLIC_IMAGE_MULTIPLIER') ?? 1,
    REVIEWS_PAGINATION_LIMIT: getEnv<number>('NEXT_PUBLIC_REVIEWS_PAGINATION_LIMIT') ?? 10,
    ACCOMMODATION_WC_APP: getEnvStringValue('ACCOMMODATION_WC_APP'),
    REGISTRATION_WC_APP: getEnvStringValue('ACCOMMODATION_WC_APP'),
    GOOGLE_MAPS_API_KEY: getEnvStringValue('NEXT_PUBLIC_GOOGLE_MAPS_API_KEY'),
    GOOGLE_MAPS_MAP_ID: getEnvStringValue('NEXT_PUBLIC_GOOGLE_MAPS_MAP_ID'),
    COOKIE_DOMAIN: getEnvStringValue('NEXT_PUBLIC_COOKIE_DOMAIN'),
    DEFAULT_FLEX_DATES: getEnv<number>('NEXT_PUBLIC_DEFAULT_FLEX_DATES') ?? 0,
    OTA_RATING_ES_VERSION: getEnv<number | undefined>('NEXT_PUBLIC_OTA_RATING_ES_VERSION'),
    LINKSPACES_ES_VERSION: getEnv<number | undefined>('NEXT_PUBLIC_LINKSPACES_ES_VERSION'),
    LISTING_BREADCRUMBS_ES_VERSION:
        getEnv<number | undefined>('NEXT_PUBLIC_LISTING_BREADCRUMBS_ES_VERSION') ?? 1,
    POI_ES_VERSION: getEnv<number | undefined>('NEXT_PUBLIC_POI_ES_VERSION') ?? 1,
    CMS_API_ENDPOINT: getEnvStringValue('CMS_API_ENDPOINT') ?? '',
    CMS_API_TOKEN: getEnvStringValue('CMS_API_TOKEN'),
    CMS_PREVIEW_SECRET: getEnvStringValue('CMS_PREVIEW_SECRET'),
    API_TIMEOUT: getEnv<number>('NEXT_PUBLIC_API_TIMEOUT', 'API_TIMEOUT') ?? 3000,
    SMART_BANNER_URL:
        getEnvStringValue('NEXT_PUBLIC_SMART_BANNER_URL') || 'https://smart.link/ggru4xy9zq545',
    GROWTHBOOK: {
        API_HOST: getEnvStringValue('GROWTHBOOK_API_HOST') ?? '',
        CLIENT_KEY: getEnvStringValue('GROWTHBOOK_CLIENT_KEY') ?? '',
        WEBHOOK_TOKEN: getEnvStringValue('GROWTHBOOK_WEBHOOK_TOKEN') ?? '',
        DEFAULT_TIMEOUT: getEnv<number>('GROWTHBOOK_DEFAULT_TIMEOUT') ?? 2000,
        REVALIDATE_TIME: getEnv<number>('GROWTHBOOK_REVALIDATE_TIME') ?? 10000,
        REVALIDATE_TAG: getEnvStringValue('GROWTHBOOK_REVALIDATE_TAG') ?? 'growthbook',
    },
    METADATA_TITLE_PRICE_DEFAULT: getEnvStringValue('METADATA_TITLE_PRICE_DEFAULT') ?? 65,
    HIGH_PRIORITY_IMAGE_COUNT_DESKTOP:
        getEnv<number>(
            'NEXT_PUBLIC_HIGH_PRIORITY_IMAGE_COUNT_DESKTOP',
            'HIGH_PRIORITY_IMAGE_COUNT_DESKTOP',
        ) ?? 3,
    HIGH_PRIORITY_IMAGE_COUNT_MOBILE:
        getEnv<number>(
            'NEXT_PUBLIC_HIGH_PRIORITY_IMAGE_COUNT_MOBILE',
            'HIGH_PRIORITY_IMAGE_COUNT_MOBILE',
        ) ?? 2,
};
